<template>
  <!-- The 2026 mark (the app's CloudLoopMark): a cloud with a loop cut out.
       Detailed (arrowhead) from 32 px, arrowless below. -->
  <svg
    :width="size"
    :height="size * (34 / 54)"
    viewBox="5 15 54 34"
    role="img"
    :aria-label="label"
    class="cl-mark"
  >
    <path :fill="color" fill-rule="evenodd" :d="path" />
  </svg>
</template>

<script>
const PLAIN =
  "M16 47A9.5 9.5 0 0 1 18.6 28.4A14.5 14.5 0 0 1 45.4 27.2A9.5 9.5 0 0 1 48 47Z " +
  "M39.55 29.35A9.3 9.3 0 1 0 39.55 38.65L35.66 36.4A4.8 4.8 0 1 1 35.66 31.6Z";
const DETAILED =
  "M16 47A9.5 9.5 0 0 1 18.6 28.4A14.5 14.5 0 0 1 45.4 27.2A9.5 9.5 0 0 1 48 47Z " +
  "M39.12 28.67A9.3 9.3 0 1 0 40.24 37.18L36.67 35.88A5.5 5.5 0 1 1 36.01 30.85" +
  "L33.63 32.51L38.86 33.23L41.49 27Z";

export default {
  name: "ClMark",
  props: {
    // Width of the cloud in px; height follows the 54:34 crop.
    size: { type: Number, default: 32 },
    // The app chrome mark is the bare violet cloud.
    color: { type: String, default: "#a855f7" },
    label: { type: String, default: "cloudloop" },
  },
  computed: {
    path() {
      return this.size >= 32 ? DETAILED : PLAIN;
    },
  },
};
</script>

<style scoped>
.cl-mark {
  display: block;
  flex-shrink: 0;
}
</style>
